import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const ContainerTitleWithNumber = styled.div`
  display: flex;
  align-items: center;
`;

//Body
export const ContainerBody = styled.div`
  padding: 0 24px;
`;

//List
export const ContainerList = styled.div`
  width: 100%;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
`;
